interface NavAttributes {
  [propName: string]: any;
}
interface NavWrapper {
  attributes: NavAttributes;
  element: string;
}
interface NavBadge {
  text: string;
  variant: string;
}
interface NavLabel {
  class?: string;
  variant: string;
}

export interface NavData {
  name?: string;
  url?: string;
  icon?: string;
  badge?: NavBadge;
  title?: boolean;
  children?: NavData[];
  variant?: string;
  attributes?: NavAttributes;
  divider?: boolean;
  class?: string;
  label?: NavLabel;
  wrapper?: NavWrapper;
}

export const navItems: NavData[] = [
  {
    name: 'Dashboard',
    url: '/coreui/dashboard',
    icon: 'icon-speedometer',
    badge: {
      variant: 'info',
      text: 'NEW'
    }
  },
  {
    title: true,
    name: 'Theme'
  },
  {
    name: 'Colors',
    url: '/coreui/theme/colors',
    icon: 'icon-drop'
  },
  {
    name: 'Typography',
    url: '/coreui/theme/typography',
    icon: 'icon-pencil'
  },
  {
    title: true,
    name: 'Components'
  },
  {
    name: 'Base',
    url: '/coreui/base',
    icon: 'icon-puzzle',
    children: [
      {
        name: 'Cards',
        url: '/coreui/base/cards',
        icon: 'icon-puzzle'
      },
      {
        name: 'Carousels',
        url: '/coreui/base/carousels',
        icon: 'icon-puzzle'
      },
      {
        name: 'Collapses',
        url: '/coreui/base/collapses',
        icon: 'icon-puzzle'
      },
      {
        name: 'Forms',
        url: '/coreui/base/forms',
        icon: 'icon-puzzle'
      },
      {
        name: 'Pagination',
        url: '/coreui/base/paginations',
        icon: 'icon-puzzle'
      },
      {
        name: 'Popovers',
        url: '/coreui/base/popovers',
        icon: 'icon-puzzle'
      },
      {
        name: 'Progress',
        url: '/coreui/base/progress',
        icon: 'icon-puzzle'
      },
      {
        name: 'Switches',
        url: '/coreui/base/switches',
        icon: 'icon-puzzle'
      },
      {
        name: 'Tables',
        url: '/coreui/base/tables',
        icon: 'icon-puzzle'
      },
      {
        name: 'Tabs',
        url: '/coreui/base/tabs',
        icon: 'icon-puzzle'
      },
      {
        name: 'Tooltips',
        url: '/coreui/base/tooltips',
        icon: 'icon-puzzle'
      }
    ]
  },
  {
    name: 'Buttons',
    url: '/coreui/buttons',
    icon: 'icon-cursor',
    children: [
      {
        name: 'Buttons',
        url: '/coreui/buttons/buttons',
        icon: 'icon-cursor'
      },
      {
        name: 'Dropdowns',
        url: '/coreui/buttons/dropdowns',
        icon: 'icon-cursor'
      },
      {
        name: 'Brand Buttons',
        url: '/coreui/buttons/brand-buttons',
        icon: 'icon-cursor'
      }
    ]
  },
  {
    name: 'Charts',
    url: '/coreui/charts',
    icon: 'icon-pie-chart'
  },
  {
    name: 'Icons',
    url: '/coreui/icons',
    icon: 'icon-star',
    children: [
      {
        name: 'CoreUI Icons',
        url: '/coreui/icons/coreui-icons',
        icon: 'icon-star',
        badge: {
          variant: 'success',
          text: 'NEW'
        }
      },
      {
        name: 'Flags',
        url: '/coreui/icons/flags',
        icon: 'icon-star'
      },
      {
        name: 'Font Awesome',
        url: '/coreui/icons/font-awesome',
        icon: 'icon-star',
        badge: {
          variant: 'secondary',
          text: '4.7'
        }
      },
      {
        name: 'Simple Line Icons',
        url: '/coreui/icons/simple-line-icons',
        icon: 'icon-star'
      }
    ]
  },
  {
    name: 'Notifications',
    url: '/coreui/notifications',
    icon: 'icon-bell',
    children: [
      {
        name: 'Alerts',
        url: '/coreui/notifications/alerts',
        icon: 'icon-bell'
      },
      {
        name: 'Badges',
        url: '/coreui/notifications/badges',
        icon: 'icon-bell'
      },
      {
        name: 'Modals',
        url: '/coreui/notifications/modals',
        icon: 'icon-bell'
      }
    ]
  },
  {
    name: 'Widgets',
    url: '/coreui/widgets',
    icon: 'icon-calculator',
    badge: {
      variant: 'info',
      text: 'NEW'
    }
  },
  {
    divider: true
  },
  {
    title: true,
    name: 'Extras',
  },
  {
    name: 'Pages',
    url: '/coreui/pages',
    icon: 'icon-star',
    children: [
      {
        name: 'Login',
        url: '/coreui/login',
        icon: 'icon-star'
      },
      {
        name: 'Register',
        url: '/coreui/register',
        icon: 'icon-star'
      },
      {
        name: 'Error 404',
        url: '/coreui/404',
        icon: 'icon-star'
      },
      {
        name: 'Error 500',
        url: '/coreui/500',
        icon: 'icon-star'
      }
    ]
  },
  {
    name: 'Disabled',
    url: '/coreui/dashboard',
    icon: 'icon-ban',
    badge: {
      variant: 'secondary',
      text: 'NEW'
    },
    attributes: { disabled: true },
  },
  {
    name: 'Download CoreUI',
    url: 'http://coreui.io/angular/',
    icon: 'icon-cloud-download',
    class: 'mt-auto',
    variant: 'success',
    attributes: { target: '_blank', rel: 'noopener' }
  },
  {
    name: 'Try CoreUI PRO',
    url: 'http://coreui.io/pro/angular/',
    icon: 'icon-layers',
    variant: 'danger',
    attributes: { target: '_blank', rel: 'noopener' }
  }
];
